import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsDirectory, CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const CatalogItemBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { open } = useCommands();
    const {
        selectedCatalogItemCount = 0,
        catalogItemBulkClassTree,
        catalogItemBulkIncomeAccountOptions,
        catalogItemBulkReceivablesAccountOptions,
        catalogItemBulkArchiveCount = 0,
        catalogItemBulkEnableCount = 0,
        onCatalogItemBulkArchive,
        onCatalogItemBulkEnable,
    } = options;

    return (
        <Command.Group
            heading={`${pluralizeWithCount("item", selectedCatalogItemCount)} selected`}
        >
            {catalogItemBulkClassTree &&
                catalogItemBulkClassTree.length > 0 && (
                    <CommandItem
                        keywords={["class", "classification"]}
                        shortcut="l"
                        onSelect={() =>
                            open(
                                CommandsDirectory.CATALOG_ITEM_BULK_CLASS,
                                options,
                            )
                        }
                    >
                        Set class
                    </CommandItem>
                )}
            {catalogItemBulkIncomeAccountOptions &&
                catalogItemBulkIncomeAccountOptions.length > 0 && (
                    <CommandItem
                        keywords={["income", "revenue", "account"]}
                        onSelect={() =>
                            open(
                                CommandsDirectory.CATALOG_ITEM_BULK_INCOME_ACCOUNT,
                                options,
                            )
                        }
                    >
                        Income account
                    </CommandItem>
                )}
            {catalogItemBulkReceivablesAccountOptions &&
                catalogItemBulkReceivablesAccountOptions.length > 0 && (
                    <CommandItem
                        keywords={["receivables", "accounts receivable", "ar"]}
                        onSelect={() =>
                            open(
                                CommandsDirectory.CATALOG_ITEM_BULK_RECEIVABLES_ACCOUNT,
                                options,
                            )
                        }
                    >
                        Receivables account
                    </CommandItem>
                )}
            {onCatalogItemBulkEnable && catalogItemBulkEnableCount > 0 && (
                <CommandItem
                    keywords={["enable", "unarchive", "restore", "activate"]}
                    onSelect={onCatalogItemBulkEnable}
                >
                    Enable{" "}
                    {pluralizeWithCount("item", catalogItemBulkEnableCount)}
                </CommandItem>
            )}
            {onCatalogItemBulkArchive && catalogItemBulkArchiveCount > 0 && (
                <CommandItem
                    keywords={["archive", "disable", "deactivate"]}
                    onSelect={onCatalogItemBulkArchive}
                >
                    Archive{" "}
                    {pluralizeWithCount("item", catalogItemBulkArchiveCount)}
                </CommandItem>
            )}
        </Command.Group>
    );
};
